// @flow
type StoreType = {
  liveEvents: Array<Object>,
  fetching: boolean,
  fetched: boolean
};

export function liveEvents(
  state: StoreType = {
    liveEvents: [],
    fetching: false,
    fetched: false
  },
  action: Object
) {
  switch (action.type) {
    case 'SET_LIVE_EVENTS': {
      const newState = { ...state };
      newState.liveEvents = {
        ...state.liveEvents,
        ...action.contents
      };
      newState.fetched = true;
      newState.fetching = false;
      return newState;
    }
    case 'SET_LIVE_EVENTS_FETCHING_STATUS': {
      const newState = { ...state };
      newState.fetching = action.fetching;
      return newState;
    }
    default:
      return state;
  }
}
